import React from 'react';
import './Events.css';

function Diary() {
  return (
    <div className="container">
      <h1 className="page-title">Дневник</h1>
      
      <div className="events-coming-soon">
        <div className="coming-soon-icon">📝</div>
        <h2>Раздел в разработке</h2>
        <p>
          Здесь будут милые заметки о повседневной жизни Софии.
          Мы будем делиться забавными историями и важными моментами её развития.
        </p>
      </div>
    </div>
  );
}

export default Diary; 